import React from "react";
import { Link } from "react-router-dom";
import foxHero from "../assets/ChatGPT_Image_May_19__2025__01_18_38_PM-removebg-preview.png"; 
import foxExtra from "../assets/fox_strong_orange.png";
import "./Ballina.css";
import { TrainingsSection } from "./TrainingsSection";
import { TestimonialsCarousel } from "./TestimonialsCarousel";
import { InternshipSection } from "./InternshipSection";
import { Footer } from "./Footer";

export default function Ballina() {
  return (
    <>
      {/* HERO section */}
      <section className="ballina-hero-vertical">
        <h1>
          FOX IT | REGJISTRO KURSIN<br />
          ME FOX ACADEMY – ZBULO VETVETEN KREATIVE!
        </h1>
        <img src={foxHero} alt="Fox Sticker Hero" className="hero-fox-img" />
      </section>

      {/* WHITE section */}
      <section className="ballina-extra-section">
        <div className="ballina-extra-image">
          <img src={foxExtra} alt="Fox Academy" />
        </div>
        <div className="ballina-extra-text">
          <h2>
            Bashkohu me FOX Academy<br />
            & hap potencialin tënd kreativ!
          </h2>
          <p>
            Kurset tona janë të ndërtuara për tregun e punës: Dizajn Grafik, Foto & Video, Programim për të gjitha moshat, Frontend, Wordpress dhe Inteligjencë Artificiale.
            <br /><br />
            Eksperienca jonë, qasja praktike, dhe partneritetet me kompani lidhen direkt me suksesin tënd profesional. Nuk je vetëm student, por një anëtar i komunitetit më të madh kreativ në Kosovë!
          </p>
          {/* Replace Apply with View Trainings link */}
          <Link to="/kurset" className="ballina-extra-btn">
            Shiko trajnimet tona
          </Link>
        </div>
      </section>

      {/* Other sections */}
      <TrainingsSection />
      <TestimonialsCarousel />
      <InternshipSection />
      <Footer />
    </>
  );
}
